module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.chapter) ? _c('div', [_vm._v(_vm._s(_vm.$t("grammarGame.game-page.loading")))]) : _vm._e(), _vm._v(" "), (_vm.chapter) ? _c('div', {
    staticClass: "grammar-page"
  }, [_c('GameHeader', {
    attrs: {
      "currentData": _vm.data,
      "externalData": _vm.externalData,
      "word": _vm.currentWord,
      "WIN": _vm.WIN,
      "status": _vm.status
    }
  }), _vm._v(" "), (_vm.isSummary) ? _c('GameSummary', {
    attrs: {
      "msg": _vm.msg,
      "playedItems": _vm.currItems,
      "mistakes": _vm.mistakes,
      "currentData": _vm.data,
      "externalData": _vm.externalData
    },
    on: {
      "restartGame": _vm.restartGame
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSummary) ? _c('div', {
    staticClass: "game-main"
  }, [(_vm.question) ? _c('div', {
    staticClass: "question"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [(!_vm.question.onlyAudio) ? _c('span', {
    key: _vm.question.qWord.eng,
    staticClass: "q"
  }, [_vm._v("\n            " + _vm._s(_vm.question.qWord.eng))]) : _vm._e()]), _vm._v(" "), (_vm.question.qWord.id) ? _c('AudioBtn', {
    attrs: {
      "urlId": _vm.question.qWord.id,
      "autoplay": _vm.autoPlay,
      "idx": _vm.idx
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.question) ? _c('ul', {
    staticClass: "answers grid"
  }, _vm._l((_vm.question.answers), function(answer) {
    return _c('li', {
      key: answer.objectID,
      class: {
        right: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        wrong: _vm.choosenId === answer.objectID &&
          _vm.question.qWord.objectID !== answer.objectID,
        nope: _vm.choosenId && _vm.question.qWord.objectID !== answer.objectID,
        rightword: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        damnright: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID
      },
      on: {
        "click": function($event) {
          return _vm.checkAnswerA(answer, _vm.idx)
        }
      }
    }, [_vm._v("\n          " + _vm._s(answer.heb) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [(_vm.showNext) ? _c('button', {
    staticClass: "btn-next",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-page.next_q")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.submitting) ? _c('button', {
    staticClass: "btnSum"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showResults) ? _c('button', {
    staticClass: "btnSum",
    on: {
      "click": _vm.showSummary
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-page.summery")) + "\n      ")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3bbca8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GrammarGame/game-page.vue
// module id = 426
// module chunks = 1 3